export const textFormatter = (e:any) => {
  if (e.value === undefined || e.value === '' || e.value === null) {
    return 'N/A'
  }
  return e.value;
};